import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client.ts';
import { ScoreBadge } from '../components/ScoreBadge.tsx';

export function Opportunities() {
  const { data, isLoading } = useQuery({
    queryKey: ['opportunities'],
    queryFn: () => api.listOpportunities()
  });

  if (isLoading) return <div>Loading...</div>;

  return (
    <div style={{ padding: '24px' }}>
      <h1>Opportunities (High Intent)</h1>
      <p style={{ color: '#94a3b8' }}>Prospects who have crossed the intent handoff threshold.</p>
      
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '24px' }}>
        {data?.map(opp => (
          <div key={opp.id} style={{ border: '1px solid #334155', padding: '20px', borderRadius: '8px', background: '#1e293b' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
              <h3 style={{ margin: 0 }}>{opp.companyName}</h3>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Intent: <ScoreBadge score={opp.intentScore} />
              </div>
            </div>
            
            <div style={{ fontSize: '14px', marginBottom: '16px' }}>
              <strong>Decision Maker:</strong> {opp.personName} ({opp.personTitle})
            </div>
            
            <div style={{ marginBottom: '16px' }}>
              <strong>Communication History:</strong>
              <ul style={{ margin: '8px 0', paddingLeft: '20px', fontSize: '14px' }}>
                <li>Outreach sent: {opp.outreachSentAt ? new Date(opp.outreachSentAt).toLocaleDateString() : 'N/A'}</li>
                <li>Replies received: {opp.replyCount ?? 0}</li>
                <li>Last active: {opp.lastInteractionAt ? new Date(opp.lastInteractionAt).toLocaleDateString() : 'N/A'}</li>
              </ul>
            </div>
            
            <button
              onClick={async () => {
                const brief = await api.createHandoff(opp.prospectId);
                alert('Sales brief generated: \n' + brief.summary);
              }}
              style={{ background: '#2563eb', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', width: '100%' }}
            >
              Generate Sales Brief
            </button>
          </div>
        ))}
        {data?.length === 0 && (
          <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '40px', color: '#94a3b8' }}>
            No opportunities available yet.
          </div>
        )}
      </div>
    </div>
  );
}
